const certificatePublicKeys = {
  d4b1165c86075cde: {
    algorithm: 'Ed25519',
    publicKeyPem: `-----BEGIN PUBLIC KEY-----
MCowBQYDK2VwAyEAsQ2SFYguM6WCB11iBx/liMqv+qzQ2OKFIfzQmeyFEu4=
-----END PUBLIC KEY-----`,
  },
};

export default certificatePublicKeys;
